(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spin-featured-spotlight"] && !Shopify.designMode) return;
  try {
    
  class SpinSpotlightComponent extends HTMLElement {
    #currentIndex = 0;
    #timer = null;

    connectedCallback() {
      this.#currentIndex = 0;
      this.#updateSlides();
      this.#bindDots();
      this.#initAutoplay();
    }

    disconnectedCallback() {
      this.#stopAutoplay();
    }

    get #slides() {
      return this.querySelectorAll(':scope > .spin-featured-spotlight__slides > slideshow-slide');
    }

    get #dots() {
      return this.querySelectorAll('.slideshow-controls__dots button');
    }

    get #autoplayEnabled() {
      if (this.dataset.autoplay !== 'true') return false;
      if (this.#slides.length < 2) return false;
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    get #autoplayInterval() {
      const seconds = Number(this.dataset.autoplayInterval) || 5;
      return seconds * 1000;
    }

    #bindDots() {
      for (const [i, dot] of [...this.#dots].entries()) {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          this.#currentIndex = i;
          this.#updateSlides();
          this.#restartAutoplay();
        });
      }
    }

    #initAutoplay() {
      if (!this.#autoplayEnabled) return;

      // Pause while the user is hovering or interacting with the carousel
      this.addEventListener('mouseenter', () => this.#stopAutoplay());
      this.addEventListener('mouseleave', () => this.#startAutoplay());
      this.addEventListener('focusin', () => this.#stopAutoplay());
      this.addEventListener('focusout', (e) => {
        if (this.contains(e.relatedTarget)) return;
        this.#startAutoplay();
      });

      this.#startAutoplay();
    }

    #startAutoplay() {
      if (!this.#autoplayEnabled || this.#timer) return;
      this.#timer = setInterval(() => this.#advance(), this.#autoplayInterval);
    }

    #stopAutoplay() {
      if (!this.#timer) return;
      clearInterval(this.#timer);
      this.#timer = null;
    }

    #restartAutoplay() {
      this.#stopAutoplay();
      this.#startAutoplay();
    }

    #advance() {
      const count = this.#slides.length;
      if (count < 2) return;
      this.#currentIndex = (this.#currentIndex + 1) % count;
      this.#updateSlides();
    }

    #updateSlides() {
      for (const [i, slide] of [...this.#slides].entries()) {
        slide.setAttribute('aria-hidden', String(i !== this.#currentIndex));
      }

      for (const [i, dot] of [...this.#dots].entries()) {
        dot.setAttribute('aria-selected', String(i === this.#currentIndex));
      }
    }
  }

  customElements.define('spin-spotlight-component', SpinSpotlightComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spin-footer"]) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('.spin-footer');
    for (const root of roots) {
      const checkbox = root.querySelector('[data-spin-footer-research]');
      if (!checkbox) continue;
      const targetId = checkbox.dataset.tagsTarget;
      const tagValue = checkbox.dataset.tagValue || '';
      const tagsInput = targetId ? root.querySelector('#' + targetId) : null;
      if (!tagsInput) continue;
      checkbox.addEventListener('change', () => {
        tagsInput.value = checkbox.checked ? tagValue : '';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
